"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECorporationResidenceFiscaleTrads = void 0;
exports.ECorporationResidenceFiscaleTrads = {
    franceDomTom: "France",
    UE: "UE",
    horsUE: "Hors UE",
};
